import { TableCell, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles"
import PropTypes from "prop-types";
import { colors, formatCurrency } from "common";

const useStyles = makeStyles(
  {
    tableCellBorder: {
      borderRight: "0.5px solid black",
      borderColor: colors.primary,
      display: "flex",
      flexDirection: "row",
    },
  },
  { index: 999 }
);

export const TableCellPromoPrice = ({ data }) => {
  const classes = useStyles();

  return (
    <TableCell className={classes.tableCellBorder}>
      <Typography color={colors.red.A700} fontWeight="900" fontSize={16}>
        {formatCurrency(data.promo_price || 0, "PHP")}
      </Typography>
      <Typography
        color={colors.grey[500]}
        style={{
          marginLeft: 10,
          fontSize: 15,
          textDecoration: "line-through",
        }}
        fontWeight="900"
        fontSize={16}
      >
        {formatCurrency(data.standard_price || 0, "PHP")}
      </Typography>
    </TableCell>
  );
};

TableCellPromoPrice.propTypes = {
  data: PropTypes.object.isRequired,
};

export default TableCellPromoPrice;
